import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css'; // Nous créerons ce fichier CSS plus tard

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Conditions Générales d'Utilisation</h1>
        <div className="legal-content">
          <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
          
          <h2>1. Introduction</h2>
          <p>Bienvenue sur NaturoBooK, la plateforme de réservation de consultations de naturopathie. En utilisant notre site, vous acceptez les présentes conditions générales d'utilisation. Nous vous invitons à les lire attentivement.</p>
          
          <h2>2. Définitions</h2>
          <p><strong>"NaturoBooK"</strong> désigne la plateforme de réservation en ligne accessible à l'adresse https://prise-de-rdv-611d6.web.app/.</p>
          <p><strong>"Utilisateur"</strong> désigne toute personne qui utilise la plateforme NaturoBooK.</p>
          <p><strong>"Praticien"</strong> désigne les professionnels de santé proposant des services via la plateforme.</p>
          <p><strong>"Client"</strong> désigne les utilisateurs prenant rendez-vous avec un praticien.</p>
          
          <h2>3. Services proposés</h2>
          <p>NaturoBooK permet la mise en relation entre des praticiens et des clients pour la prise de rendez-vous de consultations de naturopathie ou services associés.</p>
          <p>La plateforme permet :</p>
          <ul>
            <li>Aux clients de consulter les disponibilités des praticiens et prendre rendez-vous</li>
            <li>Aux praticiens de gérer leur agenda et leurs disponibilités</li>
            <li>L'envoi de notifications par email pour confirmer, rappeler ou annuler des rendez-vous</li>
          </ul>
          
          <h2>4. Inscription et compte utilisateur</h2>
          <p>L'utilisation complète des services de NaturoBooK nécessite la création d'un compte utilisateur. Lors de l'inscription, vous vous engagez à fournir des informations exactes et à les maintenir à jour.</p>
          <p>Vous êtes responsable de la confidentialité de vos identifiants de connexion et de toutes les actions effectuées via votre compte.</p>
          
          <h2>5. Conditions de prise de rendez-vous</h2>
          <p>La réservation d'un rendez-vous est confirmée une fois la demande validée sur la plateforme. Un email de confirmation est alors envoyé.</p>
          <p>Le client s'engage à respecter l'heure et la date du rendez-vous.</p>
          
          <h2>6. Politique d'annulation</h2>
          <p>Les annulations sont possibles via la plateforme selon les conditions suivantes :</p>
          <ul>
            <li>Annulation gratuite jusqu'à 24h avant le rendez-vous</li>
            <li>Passé ce délai, le praticien se réserve le droit de facturer des frais d'annulation selon sa politique propre</li>
          </ul>
          <p>Les praticiens peuvent également annuler ou reporter un rendez-vous en respectant un préavis raisonnable.</p>
          
          <h2>7. Responsabilités</h2>
          <p><strong>Responsabilité de NaturoBooK :</strong> NaturoBooK agit uniquement comme intermédiaire technique facilitant la mise en relation entre clients et praticiens. Nous ne pouvons être tenus responsables de la qualité des consultations ou de tout litige entre un client et un praticien.</p>
          <p><strong>Responsabilité des praticiens :</strong> Les praticiens sont seuls responsables des soins et conseils prodigués, ainsi que du respect des lois et réglementations applicables à leur profession.</p>
          <p><strong>Responsabilité des clients :</strong> Les clients sont responsables du respect des rendez-vous pris et des informations fournies.</p>
          
          <h2>8. Limitation de responsabilité</h2>
          <p>NaturoBooK ne pourra être tenu responsable des dommages indirects résultant de l'utilisation de la plateforme, incluant notamment les pertes de données, pertes financières ou interruptions d'activité.</p>
          
          <h2>9. Propriété intellectuelle</h2>
          <p>Tous les éléments de la plateforme NaturoBooK (textes, images, logos, code, etc.) sont protégés par le droit de la propriété intellectuelle et restent la propriété exclusive de leurs auteurs.</p>
          
          <h2>10. Modification des CGU</h2>
          <p>NaturoBooK se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés des modifications substantielles.</p>
          
          <h2>11. Loi applicable et juridiction compétente</h2>
          <p>Les présentes CGU sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
          
          <h2>12. Contact</h2>
          <p>Pour toute question concernant ces conditions, vous pouvez nous contacter à contact@naturobook.fr.</p>
        </div>
        
        <div className="legal-navigation">
          <Link to="/privacy-policy" className="btn btn-outline">Voir la Politique de Confidentialité</Link>
          <Link to="/" className="btn btn-primary">Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;